import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import "../../App.css";
import DownloadVideoAnimaton from "../Animations/DownloadVideoAnimaton";
import EmbedVideo from "../Layout/EmbedVideo";
import FreeDownload from "../Layout/FreeDownload";
import PaidDownload from "../Layout/PaidDownload";
import UrlToolTip from "../Layout/UrlToolTip";
import axios from 'axios'
import CaptionDownload from "../Layout/CaptionDownload";
import { BASE_PATH } from "../../constants/awsBaseUrl";
const ShareButton = ({
  setItemBeingBought,
  // Props
  buttonText,
  color,
  copied,
  downloadPercentage,
  downloadsDisabled,
  file = {},
  checkout,
  embedCopy,
  // onClicks
  onCopyUrlClick,
  onDownloadVideoClick,
  onCheckoutClick,
  onEmbedVideoClick,
  // Tool tips text
  copyUrlToolTip,
  copyUrlToolTipPlacement,
  downloadVideoToolTip,
  payForVideoToolTip,
  embedToolTip,
  embedToolTipPlacement,
  translations,
  setPopup
}) => {
  /* Destructured Notes

  Components purpose is to add options to a button called "Share"

  *** Props ***
  buttonText: String that represents what the button says
  shared: adds "Flex" or "none" to the CSS property "Display"
  color: changes the animation background color
  copied: boolean state that changes when a link is copied
  downloadPercentage: What the download percentage is at
  file: the same file that is attached to the video id
  checkout: boolean state that will change if user tries to purchase a video for download
  embedCopy: boolean state that changes when a embedded video has been copied

  *** onClicks ***
  onCopyUrlClick: method that copies the url, this will also set "copied" to true
  onDownloadVideoClick: Ensures the user is logged in, makes a post request to download the video
  onEmbedVideoClick: Creates and iframe which holds the 
  onCheckoutClick: Checks if user is logged in, if not then send to register page otherwise sets checkout to true

  ***ReactToolTip***
  Using a packaged to create tooltips when hovering over the different options
  Wrap an "a" tag around the content you want to have a tool tip on
  Use ReactToolTip component to explicitly have what the tooltip says and 
  allows for changing the tooltip color, location etc
  The first option has notes for clarification

  copyUrlToolTip: Enter a string when passing this prop to this component. Takes that string to be used for the Copy URL Icon
  embedToolTip: Enter a string when passing this prop to this component. Takes that string to be used for the Embed Icon
  */

  const [shared, setShared] = useState(false);
  const [captioned, setCaptioned] = useState(null)
  useEffect(()=>{
    if (file._id){
      axios.get(`${BASE_PATH}/captions/${file._id}.vtt`).then(res=>setCaptioned(true)).catch(err=>setCaptioned(false))
    }
  },[file])

  // Closes the options menu
  const onExitClick = () => {
    setShared(false);
    copied = false;
    embedCopy = false;
    checkout = false;
  };

  const setSharedToTrue = () => {
    setShared(true);
  };

  return (
    <div className={"social-item text-secondary"}>
      {/* Share Arrow Icon */}
      <i
        className={"fas fa-share text-secondary mr-2"}
        onClick={setSharedToTrue}
        style={{ cursor: "pointer" }}
        data-tip
        data-for="shareOptions"
      ></i>
      <ReactTooltip id="shareOptions" type="dark" effect="solid" place="bottom">
        <span>Share Options</span>
      </ReactTooltip>
      {buttonText}
      <div
        // Animation after clicking share arrow icon
        className={"share-options " + (shared ? "share-animate" : "")}
        style={{
          backgroundColor: color,
          display: shared ? "flex" : "none",
        }}
      >
        {copyUrlToolTip && (
          <UrlToolTip
            copied={copied}
            copyUrlToolTip={copyUrlToolTip}
            copyUrlToolTipPlacement={copyUrlToolTipPlacement}
            onCopyUrlClick={onCopyUrlClick}
          />
        )}
        {file.switches && (
          <>
            <DownloadVideoAnimaton downloadPercentage={downloadPercentage} />
            <PaidDownload
              downloadPercentage={downloadPercentage}
              file={file}
              checkout={checkout}
              onCheckoutClick={onCheckoutClick}
              payForVideoToolTip={payForVideoToolTip}
            />
            <FreeDownload
              downloadPercentage={downloadPercentage}
              downloadVideoToolTip={downloadVideoToolTip}
              downloadsDisabled={downloadsDisabled}
              file={file}
              onDownloadVideoClick={onDownloadVideoClick}
            />
          </>
        )}
        <EmbedVideo
          embedCopy={embedCopy}
          embedToolTip={embedToolTip}
          embedToolTipPlacement={embedToolTipPlacement}
          onEmbedVideoClick={onEmbedVideoClick}
        />
        {captioned? <CaptionDownload setPopup={setPopup} file={file} translations={translations}/> :''}
        <div className="share-item" onClick={onExitClick}>
          <i className="fas fa-times text-white"></i>
        </div>
      </div>
    </div>
  );
};

export default ShareButton;
